import { isPlatformNodeJS } from '@utils/common';

const LARGEST_RESOLVED_IMAGE_MAP = /* @__PURE__ */ new Map();
const INTERVAL_SIZE = 30;
function resolveMediaDomainImageUrl(url, desiredWidth) {
  if (!url) {
    return void 0;
  }
  const targetWidth = widthToInterval(
    desiredWidth * (isPlatformNodeJS() ? 1 : window.devicePixelRatio)
  );
  const currentlyLargestWidth = LARGEST_RESOLVED_IMAGE_MAP.get(url) ?? 0;
  const width = Math.max(targetWidth, currentlyLargestWidth);
  LARGEST_RESOLVED_IMAGE_MAP.set(url, width);
  try {
    const resolvedUrl = new URL(url);
    resolvedUrl.searchParams.set(
      mapUrlToSearchParameter(resolvedUrl),
      `${width}`
    );
    return resolvedUrl.toString();
  } catch (err) {
    console.error(err);
    return void 0;
  }
}
function widthToInterval(width) {
  return Math.ceil(width / INTERVAL_SIZE) * INTERVAL_SIZE;
}
function mapUrlToSearchParameter(url) {
  return url.host.includes("produktapi") ? "width" : "w";
}

export { resolveMediaDomainImageUrl };
//# sourceMappingURL=resolve-media-domain-image-url.js.map
